import {StoresService} from '../../../core/services/stores.service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../../../environments/environment';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';
import { PaymentsService } from '../../../core/services/payments.service';
import { MerchantsService } from '../../../core/services/merchants.service';
import { TranslateService } from '@ngx-translate/core';
import { ToolsService } from '../../../core/services/tools.service';
import { isPlatformBrowser } from '@angular/common';
import { PlansModalComponent } from '../plans-modal/plans-modal.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { debounceTime, interval, Subscription } from 'rxjs';
import { differenceInMinutes, parseISO } from 'date-fns';
import { PlansService } from '../../../core/services/plans.service';
import { AnalyticsService } from '../../../core/services/analytics.service';
import { IntlService } from '../../../core/services/intl.service';
import { vatCountryFormatValidator } from '../../../core/validators/vatCountryFormat.validator';
import { ActivatedRoute, Router } from '@angular/router';

declare var Stripe: stripe.StripeStatic;

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-payment-modal-v4',
  templateUrl: './payment-modal-v4.component.html',
  styleUrls: ['./payment-modal-v4.component.scss'],
})
export class PaymentModalV4Component implements OnInit {
  public frequencyOptions = [
    {id: 'yearly', value: this.translate.instant('SHARED.plansModal.paid-annual-plan')},
    {id: 'monthly', value: this.translate.instant('SHARED.plansModal.paid-monthly-plan')}
  ];

  public paymentMethodMonthlyOptions = [
    { id: 'mbway', value: 'MBWay' },
    { id: 'mbref', value: 'Multibanco' },
    {id: 'ccard', value: this.translate.instant('SHARED.plansModal.credit-card')},
    {id: 'sepa', value: this.translate.instant('SHARED.plansModal.direct-debit')}
  ];
  public paymentMethodAnnualyOptions = [
    {id: 'mbway', value: 'MBWay'},
    {id: 'mbref', value: 'Multibanco'},
    {id: 'ccard', value: this.translate.instant('SHARED.plansModal.credit-card')},
    {id: 'sepa', value: this.translate.instant('SHARED.plansModal.direct-debit')}
  ];
  public paymentMethodOptions;

  public loading = true;
  public loadingUpcomingInvoice: boolean;

  public currentUserObservable: Subscription;
  public activeCreditCard;

  public changePaymentMethodOnly = false;

  public merchant;
  public availablePlans;

  public quantity;
  public planId;
  public user;
  public overrideCoupon;

  public submitAttempted;
  public submitSuccess;
  public errorMsg;
  public submitting;

  public form: UntypedFormGroup;
  public presetPhoneNumber;
  public stripe: stripe.Stripe;

  public selectedPlanAnnually = null;
  public selectedPlanMonthly = null;

  public iban;
  public ibanEmpty;

  // Pre-existing card
  public card;
  public cardEmpty;
  public mbrefDetails = null;
  public waitingPayment = false;
  public paymentIntervalSubscription: Subscription;

  public showVatInput = true;

  public showPriceWithoutVat = false;
  stripeSetupIntentData: any;
  activeDirectDebit: any;
  savedVatNumber: any;

  public paramPaymentMethod;
  public paramAnnual;
  public invoice;

  public isUsingReferral = false;
  public merchantIsOnAnnualPlan = true;

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private paymentsService: PaymentsService,
    private merchantsService: MerchantsService,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
    private ref: ChangeDetectorRef,
    private translate: TranslateService,
    private toolsService: ToolsService,
    private storeService: StoresService,
    public plansService: PlansService,
    public analytics: AnalyticsService,
    @Inject(PLATFORM_ID) protected platformId,
    public intlService: IntlService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    try {
      this.initWithStripe();
    } catch (error) {
      setTimeout(() => {
        this.initWithStripe();
      }, 1000);
    }
  }

  initWithStripe() {

    this.frequencyOptions = [
      {id: 'yearly', value: this.translate.instant('SHARED.plansModal.paid-annual-plan')},
      {id: 'monthly', value: this.translate.instant('SHARED.plansModal.paid-monthly-plan')}
    ];

    this.paymentMethodMonthlyOptions = [
      { id: 'mbway', value: 'MBWay' },
      { id: 'mbref', value: 'Multibanco' },
      {id: 'ccard', value: this.translate.instant('SHARED.plansModal.credit-card')},
      {id: 'sepa', value: this.translate.instant('SHARED.plansModal.direct-debit')}
    ];
    this.paymentMethodAnnualyOptions = [
      {id: 'mbway', value: 'MBWay'},
      {id: 'mbref', value: 'Multibanco'},
      {id: 'ccard', value: this.translate.instant('SHARED.plansModal.credit-card')},
      {id: 'sepa', value: this.translate.instant('SHARED.plansModal.direct-debit')}
    ];

    this.stripe = Stripe(environment.stripe.publishableKey);

    this.setupPlans();

    // init stripe setup intent
    this.merchantsService.getMerchantSetupIntent().subscribe(async res => {
      this.stripeSetupIntentData = res;
    });
    this.checkPaymentOptions();
  }

  checkPaymentOptions() {

    const country = this.intlService.getCurrentCountry();
    if (country !== 'pt') {
      let i = this.paymentMethodMonthlyOptions.findIndex((v) => v.id === 'mbref');
      this.paymentMethodMonthlyOptions.splice(i, 1);
      i = this.paymentMethodMonthlyOptions.findIndex((v) => v.id === 'mbway');
      this.paymentMethodMonthlyOptions.splice(i, 1);
      i = this.paymentMethodAnnualyOptions.findIndex((v) => v.id === 'mbref');
      this.paymentMethodAnnualyOptions.splice(i, 1);
      i = this.paymentMethodAnnualyOptions.findIndex((v) => v.id === 'mbway');
      this.paymentMethodAnnualyOptions.splice(i, 1);
    }
    this.paymentMethodOptions = this.paymentMethodMonthlyOptions
  }

  setupPlans() {
    // if available in initialState
    if (this.availablePlans) {
      this.init();

    } else {
      const country = this.intlService.getCurrentCountry();
      // if not available in initialState
      this.paymentsService.getPlans(country).subscribe((res) => {
        // Select based on merchant currency
        const plans = res.find((v) => v.currency === this.merchant.currency);
        if (plans) {
          this.availablePlans = plans.plans;
        } else {
          this.availablePlans = res[0].plans;
        }
        this.init();
      });
    }
  }

  init() {
    this.merchantIsOnAnnualPlan = this.merchant?.stripePlan?.includes('annual');
    let plan = null;
    if (this.planId) {
      plan = this.availablePlans.find((v) => v.id === this.planId);
    } else {
      if (this.merchant.canceledSubscription) {
        plan = this.availablePlans.find((v) => v.id === this.merchant.canceledSubscription.planId);
        this.quantity = this.merchant.canceledSubscription.quantity;
      } else if (this.merchant.stripePlan) {
        plan = this.availablePlans.find((v) => v.id === this.merchant.stripePlan);
      }
    }

    let isAnnual = false;
    if (plan.interval === 'monthly') {
      this.selectedPlanMonthly = plan;
      this.selectedPlanAnnually = this.availablePlans.find((v) => v.bukId === plan.bukId && v.id.endsWith('annual'));
      isAnnual = false;
    } else {
      this.selectedPlanAnnually = plan;
      this.selectedPlanMonthly = this.availablePlans.find((v) => v.bukId === plan.bukId && !v.id.endsWith('annual'));
      isAnnual = true;
    }

    if (this.selectedPlanMonthly.priceWithoutVat) {
      this.showPriceWithoutVat = true;
    }

    this.currentUserObservable = this.userService.currentUser.subscribe((res) => {
      if (res) {
        this.user = res;
        this.storeService.getMyStores().subscribe((resStores) => {
          this.presetPhoneNumber = resStores[0].phoneNumber;
          this.getPaymentMethods(this.merchant.id, isAnnual);
        });
      }
    });
  }

  getSelectedPlanType() {
    if (this.selectedPlanMonthly?.id.includes('pro_plus') || this.selectedPlanAnnually?.id.includes('pro_plus')) {
      return 'PRO+';
    }
    return 'PRO';
  }

  getPaymentMethods(merchantId, isAnnual) {
    this.paymentsService.getPaymentMethods(merchantId).subscribe(
      (res) => {
        if (res && res.vatNumber) {
          this.savedVatNumber = res.vatNumber;
        }
        if (res && res.cardLastFour) {
          this.activeCreditCard = res;
        }
        if (res && res.ibanLastFour) {
          this.activeDirectDebit = res;
        }
        this.generateForm(isAnnual);
        this.loading = false;
      },
      (err) => {
        this.generateForm(isAnnual);
        this.loading = false;
      }
    );
  }

  generateForm(isAnnual) {
    this.isUsingReferral = this.merchant.referrerCode || false;
    let coupon;

    if (this.overrideCoupon) {
      coupon = this.overrideCoupon;
    }

    let defaultPaymentMethod = this.getDefaultPaymentMethod(isAnnual);

    if (this.savedVatNumber) {
      this.showVatInput = false;
    }

    this.form = this.fb.group({
      frequency: this.frequencyOptions.find(v => v.id === (isAnnual ? 'yearly' : 'monthly')),
      vatNumber: [this.savedVatNumber || null, [vatCountryFormatValidator(this.intlService.getCurrentCountry(), this.translate)]],
      coupon: [coupon, []],
      phoneNumber: [this.presetPhoneNumber, defaultPaymentMethod === 'mbway' ? [Validators.required] : []],
      paymentMethod: [this.findPaymentMethod(defaultPaymentMethod)],
      sepaName: ['']
    });

    if (this.activeCreditCard) {
      this.form.addControl('readOnlyCard', new UntypedFormControl('**** **** **** ' + this.activeCreditCard.cardLastFour + ' - ' + this.translate.instant('SHARED.paymentModal.validUntil') + ' ' + this.activeCreditCard?.cardValidUntil + ''));
      this.form.get('readOnlyCard').disable();
    }

    if (this.activeDirectDebit) {
      this.form.addControl('readOnlyDirectDebit', new UntypedFormControl('**** **** **** **** **** ' + this.activeDirectDebit.ibanLastFour));
      this.form.get('readOnlyDirectDebit').disable();
    }

    this.frequencyChange(this.form.get('frequency').value);
    this.paymentMethodChange(this.form.get('paymentMethod').value);

    this.form.get('frequency').valueChanges.subscribe(freq => {
       this.frequencyChange(freq);
    })
    this.form.get('paymentMethod').valueChanges.subscribe(method => {
       this.paymentMethodChange(method);
    });

    // only trigger the valueChanges after a delay without typying
    this.form.get('coupon').valueChanges.pipe(debounceTime(1000)).subscribe(coupon => {
      this.getUpcomingInvoice();
    });

    // only trigger the valueChanges after a delay without typying
    this.form.get('vatNumber').valueChanges.pipe(debounceTime(1000)).subscribe(vat => {
      if (this.form.get('vatNumber').valid) {
        this.getUpcomingInvoice();
      }
    });

    // override default annual if param is present
    if (this.paramAnnual) {
      isAnnual = this.paramAnnual === 'true';
      if (isAnnual) {
        this.form.get('frequency').patchValue(this.frequencyOptions.find(v => v.id === 'yearly'));
      }
    }
    // override default payment method if param is present
    if (this.paramPaymentMethod) {
      defaultPaymentMethod = this.paramPaymentMethod;
      this.form.get('paymentMethod').patchValue( this.findPaymentMethod(defaultPaymentMethod));
    }

  }

  findPaymentMethod(paymentMethod) {
    const foundPaymentMethod = this.paymentMethodOptions.find(v => v.id === paymentMethod);
    if (foundPaymentMethod) {
      return foundPaymentMethod;
    }

    return this.paymentMethodOptions[0];
  }

  frequencyChange(frequency) {
    this.invoice = null;
    let isYearly = false;
    if (frequency.id === 'monthly') {
      const defaultPaymentMethod = this.getDefaultPaymentMethod(false);
      this.paymentMethodOptions = this.paymentMethodMonthlyOptions;
      this.form.get('paymentMethod').patchValue( this.findPaymentMethod(defaultPaymentMethod));
    } else {
      isYearly = true;
      const defaultPaymentMethod = this.getDefaultPaymentMethod(true);
      this.paymentMethodOptions = this.paymentMethodAnnualyOptions;
      this.form.get('paymentMethod').patchValue( this.findPaymentMethod(defaultPaymentMethod));
    }

    this.getUpcomingInvoice();
  }

  getDefaultPaymentMethod(isAnnual) {
    let defaultPaymentMethod;

    if (this.merchant.lastPaymentMethodUsed && this.merchant.lastPaymentMethodUsed !== 'mbway') {
      defaultPaymentMethod = this.merchant.lastPaymentMethodUsed;
    } else if (isAnnual) {
      const country = this.intlService.getCurrentCountry();
      if (country !== 'pt') {
        defaultPaymentMethod = 'ccard'
      } else {
        defaultPaymentMethod = this.activeCreditCard ? 'ccard' : 'mbway';
      }
    } else {
      defaultPaymentMethod = this.activeDirectDebit ? 'sepa' : 'ccard';
    }

    return defaultPaymentMethod
  }

  getUpcomingInvoice() {
    this.loadingUpcomingInvoice = true;
    const isYearly = this.form.get('frequency').value.id === 'yearly';

    const planId = isYearly ? this.selectedPlanAnnually.id : this.selectedPlanMonthly.id;
    let vatNumber = this.form.value.vatNumber;
    // if vat only has numbers, add the country code (uppercase)
    if (/^\d+$/.test(vatNumber)) {
      vatNumber = this.intlService.getCurrentCountry()?.toUpperCase() + vatNumber;
    }
    const payload = {
      planId,
      quantity: this.quantity || null,
      coupon: this.validateCoupon(this.form.get('coupon').value)?.trim(),
      vatNumber,
    };

    this.paymentsService.getUpcomingInvoice(this.merchant.id, payload).subscribe((res) => {
      this.invoice = res;
      this.loadingUpcomingInvoice = false;
    });
  }

  paymentMethodChange(method) {
    if (method.id === 'ccard' || method.id === 'mbref') {
      this.form.get('phoneNumber').setValidators([]);
      this.form.get('sepaName').setValidators([]);
    } else if (method.id === 'sepa') {
      if (this.invoice?.amountToPayNow === 0) {
        this.form.get('sepaName').setValidators([]);
      } else {
        this.form.get('sepaName').setValidators([Validators.required]);
      }
      this.form.get('phoneNumber').setValidators([]);
    } else {
      this.form.get('phoneNumber').setValidators([Validators.required]);
      this.form.get('sepaName').setValidators([]);
    }
    this.form.get('phoneNumber').updateValueAndValidity();
    this.form.get('sepaName').updateValueAndValidity();
  }

  validateCoupon(coupon) {
    // do not allow to use same coupon has referralCode
    return this.merchant.referralCode === coupon ? '' : coupon;
  }

  getTotalPlanPrice(plan) {

    if (typeof this.invoice?.vatRate === 'number' && plan.priceWithoutVat) {
      const priceWithoutVat = this.plansService.getPlanPrice(plan, true, this.quantity);
      return priceWithoutVat * (100 + this.invoice?.vatRate) / 100;
    }

    return this.plansService.getPlanPrice(plan, false, this.quantity);
  }

  getReferralDiscount(plan) {

    return this.getTotalPlanPrice(plan) - (this.invoice?.amountToPayNow / 100);
  }

  getVatPrice(plan) {
    if (typeof this.invoice?.vatRate === 'number') {
      const priceWithoutVat = this.plansService.getPlanPrice(plan, true, this.quantity);

      if (this.invoice?.vatRate) {
        return priceWithoutVat * this.invoice?.vatRate / 100;
      }

      return 0;
    }

    return this.getTotalPlanPrice(plan) - this.plansService.getPlanPrice(plan, true, this.quantity);
  }

  backToPlans() {
    this.modalService.show(PlansModalComponent, { class: 'modal-md' });
    this.bsModalRef.hide();
  }

  close() {
    this.bsModalRef.hide();
  }


  // ############################################**############################################

  useDefaultPaymentMethod() {
    this.submitAttempted = true;
    this.submitSuccess = null;
    this.errorMsg = null;
    this.submitting = true;

    const payload = this.getSubscriptionPayload(this.form.get('paymentMethod').value.id);


    this.paymentsService.activatePlan(this.merchant.id, payload).subscribe(
      (res) => {
        this.merchantsService.getMerchant().subscribe();
        this.submitting = false;
        this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});

        if (isPlatformBrowser(this.platformId)) {
          localStorage?.removeItem('referral');
        }
        // setTimeout(() => {
        //   this.modalService.setDismissReason(res);
        //   this.bsModalRef.hide();
        // }, 2000);
        this.ref.detectChanges();
      },
      (err) => {
        if (err.errData && err.errData.stripeClientSecret) {
          // needs to handle payment
          this.handlePayment(err.errData.stripeClientSecret);
        } else {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      }
    );
  }

  async handleForm(e) {
    this.form.updateValueAndValidity();

    this.submitAttempted = true;
    this.submitSuccess = null;
    this.errorMsg = null;

    if (!this.form.valid) {
      // other fields errors
      this.errorMsg = ' ';
      // log form errors
      return false;
    }

    this.submitting = true;

    if (this.form.get('paymentMethod').value.id === 'ccard') {
      // CCARD
      // bypass payment validation
      if (this.invoice?.amountToPayNow === 0 && this.cardEmpty) {
        this.processCardPayment(null);
        return;
      }

      const { setupIntent, error } = await this.stripe.confirmCardSetup(
        this.stripeSetupIntentData.clientSecret,
        {
          payment_method: {
            card: this.card,
          }
        }, { handleActions: this.changePaymentMethodOnly }); // validade card with stripe

      if (error) {
        // card error
        this.errorMsg = error.message;
        this.submitting = false;
        return;
      }

      this.processCardPayment(setupIntent.payment_method);
    } else if (this.form.get('paymentMethod').value.id === 'sepa') {
      // SEPA
      // bypass payment validation
      if (this.invoice?.amountToPayNow === 0 && this.ibanEmpty) {
        this.processCardPayment(null);
        return;
      }
      const { setupIntent, error } = await this.stripe.confirmSepaDebitSetup(
        this.stripeSetupIntentData.clientSecret,
        {
          payment_method: {
            sepa_debit: this.iban,
            billing_details: {
              name: this.form.get('sepaName').value,
              email: this.stripeSetupIntentData.email,
            },
          },
        }
      )

      if (error) {
        // card error
        this.errorMsg = error.message;
        this.submitting = false;
        return;
      }

      this.processSepaDebitPayment(setupIntent.payment_method);

    } else if (this.form.get('paymentMethod').value.id === 'mbway') {
      // MBWAY
      const payload = this.getSubscriptionPayload('mbway');
      this.paymentsService.activatePlan(this.merchant.id, payload).subscribe(
        (res) => {
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;

          if (res.paid) {
            this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
            this.merchantsService.refreshMerchantSubscription().subscribe();
            this.ref.detectChanges();
          } else {
            this.waitingPayment = true;
            this.checkPayment();
          }
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      );


    } else if (this.form.get('paymentMethod').value.id === 'mbref') {
      // MULTIBANCO
      const payload = this.getSubscriptionPayload('mbref');

      this.paymentsService.activatePlan(this.merchant.id, payload).subscribe(
        (res) => {
          this.mbrefDetails = res;
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;

          if (res.paid) {
            this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
            this.merchantsService.refreshMerchantSubscription().subscribe();
            this.ref.detectChanges();
          } else {
            this.waitingPayment = true;
            this.checkPayment();
          }
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      );
    }

  }

  cancelPayment() {
    this.waitingPayment = false;
    this.checkPayment();
  }

  getSubscriptionPayload(paymentMethod, stripeToken: string = null) {
    const isYearly = this.form.get('frequency').value.id === 'yearly';
    const planId = isYearly ? this.selectedPlanAnnually.id : this.selectedPlanMonthly.id;
    let vatNumber = this.form.value.vatNumber;
    // if vat only has numbers, add the country code (uppercase)
    if (/^\d+$/.test(vatNumber)) {
      vatNumber = this.intlService.getCurrentCountry()?.toUpperCase() + vatNumber;
    }
    const payload = {
      planId,
      paymentMethod,
      quantity: this.quantity || null,
      coupon: this.validateCoupon(this.form.get('coupon').value)?.trim(),
      vatNumber,
      stripeToken: null,
      phoneNumber: null,
      sepaName: null,
      subscriptionProrationDate: this.invoice ? this.invoice.subscriptionProrationDate : null,
    };

    if (stripeToken) {
      payload.stripeToken = stripeToken;
    }


    if (paymentMethod === 'mbway') {
      payload.phoneNumber = this.form.get('phoneNumber').value;
    }

    if (paymentMethod === 'sepa') {
      payload.sepaName = this.form.get('sepaName').value;
    }

    return payload
  }

  checkPayment() {
    if (this.waitingPayment) {
      if (this.paymentIntervalSubscription && !this.paymentIntervalSubscription.closed) {
        return;
      }
      this.paymentIntervalSubscription = interval(1000 * 5).subscribe(() => {
        this.merchantsService.getMerchantLastPaiedAt().subscribe(res => {
          if (res && res.lastPaiedAt && res.paymentMethodUsed === this.form.get('paymentMethod').value.id) {
            const minutesSinceLastPaied = differenceInMinutes(new Date(), parseISO(res.lastPaiedAt));
            if (minutesSinceLastPaied <= 4) {
              this.waitingPayment = false;
              this.submitting = false;
              this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
              this.merchantsService.refreshMerchantSubscription().subscribe();
              this.ref.detectChanges();
            }
          }
        });

      });
    } else {
      if (this.paymentIntervalSubscription) {
        this.paymentIntervalSubscription.unsubscribe();
      }
    }
  }

  processSepaDebitPayment(sourceId) {
    if (this.changePaymentMethodOnly) {
      const payload = {
        stripeToken: (sourceId) || null,
      };
      this.paymentsService.updatePaymentMethod(this.merchant.id, payload).subscribe(
        (res) => {
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;
          this.submitSuccess = this.translate.instant('SHARED.paymentModal.successUpdateCard');
          setTimeout(() => {
            this.modalService.setDismissReason(res);
            this.bsModalRef.hide();
          }, 1000);
          this.ref.detectChanges();
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      );
    } else {
      const payload = this.getSubscriptionPayload('sepa', sourceId);
      this.paymentsService.activatePlan(this.merchant.id, payload).subscribe(
        (res) => {
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;
          this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
          this.ref.detectChanges();
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      );
    }
  }

  processCardPayment(sourceId) {
    if (this.changePaymentMethodOnly) {
      const payload = {
        stripeToken: (sourceId) || null,
      };
      this.paymentsService.updatePaymentMethod(this.merchant.id, payload).subscribe(
        (res) => {
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;
          this.submitSuccess = this.translate.instant('SHARED.paymentModal.successUpdateCard');
          setTimeout(() => {
            this.modalService.setDismissReason(res);
            this.bsModalRef.hide();
          }, 1000);
          this.ref.detectChanges();
        },
        (err) => {
          this.errorMsg = err.errMsg;
          this.submitting = false;
          this.ref.detectChanges();
        }
      );
    } else {
      const payload = this.getSubscriptionPayload('ccard', sourceId);
      this.paymentsService.activatePlan(this.merchant.id, payload).subscribe(
        (res) => {
          this.merchantsService.getMerchant().subscribe();
          this.submitting = false;
          this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
          // setTimeout(() => {
          //   this.modalService.setDismissReason(res);
          //   this.bsModalRef.hide();
          // }, 3000);
          this.ref.detectChanges();
        },
        (err) => {
          if (err.errData && err.errData.stripeClientSecret) {
            // needs to handle payment
            this.handlePayment(err.errData.stripeClientSecret);
          } else {
            this.errorMsg = err.errMsg;
            this.submitting = false;
            this.ref.detectChanges();
          }
        }
      );
    }
  }

  handlePayment(clientSecret) {
    this.stripe.confirmCardPayment(clientSecret).then((result) => {
      if (result.error) {
        // Display error.message in your UI.
        this.errorMsg = result.error.message;
        this.submitting = false;
        this.merchantsService.refreshMerchantSubscription().subscribe();
        this.ref.detectChanges();
      } else {
        // The payment has succeeded. Display a success message.
        this.merchantsService.refreshMerchantSubscription().subscribe();
        this.submitting = false;
        this.submitSuccess = this.translate.instant('SHARED.paymentModal.successPayment', {value: this.getSelectedPlanType()});
        // setTimeout(() => {
        //   this.modalService.setDismissReason('');
        //   this.bsModalRef.hide();
        // }, 3000);
        this.ref.detectChanges();
      }
    });
  }

  convertMBref(mbref) {
    const groups = mbref.match(/.{1,3}/g); // split into groups of 3 characters
    return groups.join(" ");
  }

  submit($event) {
    this.submitAttempted = true;
    const paymentMethod = this.form.get('paymentMethod').value.id;
    if (paymentMethod === 'ccard' && this.activeCreditCard && !this.changePaymentMethodOnly) {
      return this.useDefaultPaymentMethod();
    }

    if (paymentMethod === 'sepa' && this.activeDirectDebit && !this.changePaymentMethodOnly) {
      return this.useDefaultPaymentMethod();
    }

    this.analytics.trackProductAnalyticsEvent('subscribed', {paymentMethod: paymentMethod});
    this.analytics.trackEvent('subscribed', 'payment');

    return this.handleForm($event);
  }

  goToReferral() {
    this.close();
    const slug = this.activatedRoute.pathFromRoot[0].children[0].snapshot.params.slug;
    this.router.navigateByUrl(`/${slug}/dashboard/referral`);
  }
}
